import {
  KlarnaAuthResponse,
  KlarnaSession,
  KlarnaAuthResponseNormalized,
} from 'features/checkout/types'

const klarnaPaymentsAuthorize = (
  paymentMethodCategory: string,
  sessionUpdateBody: KlarnaSession,
): Promise<KlarnaAuthResponseNormalized> =>
  new Promise((resolve, reject) => {
    if (paymentMethodCategory && sessionUpdateBody) {
      Klarna.Payments.authorize(
        {
          payment_method_category: paymentMethodCategory,
        },
        sessionUpdateBody,
        // klarnaAuthResponse :: { approved: bool, authorization_token: string, show_form: bool }
        ({
          authorization_token: authorizationToken,
          show_form: showForm,
          approved,
        }: KlarnaAuthResponse) => resolve({ authorizationToken, showForm, approved }),
      )
    } else {
      reject(new Error('missing paymentMethodCategory or klarnaSessionResponse'))
    }
  })

export default klarnaPaymentsAuthorize
